import { render } from "./Welcome.vue?vue&type=template&id=25515269&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=25515269&scoped=true&lang=css"
import "./Welcome.vue?vue&type=style&index=1&id=25515269&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25515269"]])

export default __exports__